<template>
  <v-app id="inspire">
    <div>
      <side-navigation></side-navigation>

      <v-main>
        <div class="max-width">
          <slot></slot>
        </div>

      </v-main>
    </div>

    <!-- <v-container v-else>
    <v-row justify="center">
      <v-col cols="8" class="mt-10">
        <v-alert
          border="bottom"
          colored-border
          type="error"
          elevation="2"
        >System Error Occured !</v-alert>
      </v-col>

    </v-row>
  </v-container> -->

  </v-app>
</template>

<script>
// import TestNavigation from "../_components/subscriber-nav.vue";
import SideNavigation from "../_components/side-nav.vue";
export default {
  components: {
    // Navigation,
    SideNavigation,
  },
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
    SystemSuspended: 0,
    AdvancedMenu: "N",
  }),
  methods: {
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData.DefaultStockStore) {
              self.AdvancedMenu = res.ResponseData.AdvancedMenu;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    checkInactive() {
      // var subscriberId = localStorage.getItem("subscriber_id");
      // if(subscriberId == 220) {
      //   this.$router.push("/inactive-account");
      // }
    }
  },
  created() {
    this.getGenSettings();
    this.checkInactive();
  },
};
</script>